import { requestPublic } from "../../helpers/createRequest";

export const getLabExportById = async (id) => {
  return await requestPublic(`applicant/lab/protocol/${id}/detail/`);
};
export const getLabImportById = async (id) => {
  return await requestPublic(`applicant/lab/import-protocol/${id}/detail/`);
};
